import React from 'react';

const MissionSection = () => {
  return (
    
    <div data-aos="fade-right" className="bg-[#1e6c56] w-full py-16 px-12">
    <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-start md:items-center gap-10">
      {/* Left Content */}
      <div className="md:w-1/2">
        <h3 className="text-[#f5c956] font-bold text-sm uppercase tracking-wide">
          Our Mission
        </h3>
        <h2 className="text-white font-extrabold text-3xl md:text-4xl leading-tight">
          Empowering Communication <br />
          Across Africa with AI
        </h2>
      </div>
      <div className="md:w-1/2">
          <p className="text-white text-base font-light leading-relaxed">
            At NKENNEAi, we are dedicated
            to closing language gaps by providing high-quality, culturally aware
            translation services and language tools. Our solutions empower
            developers, businesses, and individuals to connect and communicate
            more effectively across the continent.
          </p>
          </div>
      </div>
    </div>
      
  );
};

export default MissionSection;
